import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="expenses--pdf-preview"
export default class extends Controller {
  static targets = ["previewContainer", "pdfWrapper", "previewPdf"]

  connect() {}

  // Handle file upload - only processes if it's a PDF
  handleFile(file, objectUrl) {
    if (file.type === "application/pdf") {
      this.showPreview(file, objectUrl)
    }
  }

  // Show preview from a file object
  showPreview(file, objectUrl) {
    const container = this.previewContainerTarget
    const iframe = this.previewPdfTarget

    if (!container || !iframe) return

    // Cleanup previous object URL
    this.cleanupObjectUrl()

    // Store object URL for cleanup
    if (objectUrl.startsWith("blob:")) {
      this.currentObjectUrl = objectUrl
    }

    // Update existing iframe element
    const pdfUrlWithParams = this.addPdfViewerParams(objectUrl)
    iframe.src = pdfUrlWithParams
    iframe.title = file.name

    // Update container state to show PDF (CSS handles visibility)
    container.className = container.className.replace(/document-preview-container--\w+/, "")
    container.classList.add("document-preview-container", "document-preview-container--pdf")
  }

  // Show preview from URL (for server-rendered PDFs)
  showPreviewFromUrl(pdfUrl, filename) {
    const container = this.previewContainerTarget
    const iframe = this.previewPdfTarget

    if (container && iframe) {
      const pdfUrlWithParams = this.addPdfViewerParams(pdfUrl)
      iframe.src = pdfUrlWithParams
      iframe.title = filename
      container.classList.remove("document-preview-empty")
      container.classList.add("document-preview-container")
    }
  }

  addPdfViewerParams(url) {
    // Add parameters to hide PDF toolbar and navigation panes
    // This works for most browsers (Chrome, Edge, Firefox)
    const separator = url.includes("#") ? "&" : "#"
    return `${url}${separator}toolbar=0&navpanes=0`
  }

  cleanupObjectUrl() {
    if (this.currentObjectUrl?.startsWith("blob:")) {
      try {
        URL.revokeObjectURL(this.currentObjectUrl)
      } catch (_e) {
        // Ignore errors
      }
      this.currentObjectUrl = null
    }
  }

  showEmptyPreview() {
    const container = this.previewContainerTarget
    if (!container) return

    container.className = container.className.replace(/document-preview-container--\w+/, "")
    container.classList.add("document-preview-container", "document-preview-container--empty")
  }

  disconnect() {
    // Clean up any object URLs when controller disconnects
    this.cleanupObjectUrl()
  }
}
